import { Button } from "@/components/ui/button";
import { AionSectionCard } from "@/components/aion/AionSectionCard";
import { VOICE_LANGUAGE_OPTIONS } from "@/components/aion/AionView";
import { normalizeVoiceState, VOICE_STATES } from "@/constants/voiceRuntime";

const VOICE_SETTINGS_LOCK_STATES = new Set([
  VOICE_STATES.LISTENING,
  VOICE_STATES.SPEECH_DETECTED,
  VOICE_STATES.TRANSCRIBING,
  VOICE_STATES.THINKING,
  VOICE_STATES.EXECUTING,
  VOICE_STATES.RESPONDING,
  VOICE_STATES.SPEAKING,
]);

export const AionVoiceSettings = ({ voice }) => {
  const { assistantVoiceProfile, selectedVoiceLanguages, voicePending, voiceLanguageMode, voiceLanguageModeLabel, wakeWordArmed, wakeWordSupported, voiceMuted } = voice;
  const onToggleLanguage = voice.handleVoiceLanguageToggle;
  const onEnableAutoLanguages = voice.handleVoiceAutoLanguagesSave;
  const onVoiceProfileSave = voice.handleAssistantVoiceProfileSave;
  const voiceState = normalizeVoiceState(voice.voiceStatus?.voice_state);
  const settingsLocked = Boolean(voicePending) || VOICE_SETTINGS_LOCK_STATES.has(voiceState);
  return (
      <AionSectionCard
        title="Sprache & Stimme"
        eyebrow="EINSTELLUNGEN → AION"
        subtitle="Wähle eine feste Sprache oder aktiviere AUTO für alle 38 unterstützten Sprachen."
        action={<span className="aion-status-chip" data-testid="voice-language-save-state">Direkt gespeichert</span>}
        testId="voice-language-picker"
      >
        <div className="aion-inline-actions" data-testid="voice-language-mode-actions">
          <Button
            type="button"
            variant={voiceLanguageMode === "auto" ? "default" : "outline"}
            onClick={onEnableAutoLanguages}
            disabled={settingsLocked}
            data-testid="voice-language-auto-all"
          >
            AUTO · Alle 38 Sprachen
          </Button>
          <span>{voiceLanguageMode === "auto" ? "AION erkennt die Sprache automatisch." : "Ein Sprachklick sperrt AION auf genau diese Sprache."}</span>
        </div>

        <div className="aion-language-grid" data-testid="voice-language-grid">
          {VOICE_LANGUAGE_OPTIONS.map((item) => (
            <button
              type="button"
              key={item.value}
              className={`aion-language-chip${selectedVoiceLanguages.includes(item.value) ? " aion-language-chip-active" : ""}`}
              onClick={() => onToggleLanguage(item.value)}
              disabled={settingsLocked}
              aria-disabled={settingsLocked}
              data-testid={`voice-language-chip-${item.value}`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="aion-voice-profile-picker" data-testid="aion-voice-profile-picker">
          <div>
            <strong>AION Erscheinung & Stimme</strong>
            <small>Stimme und Avatar bleiben immer gekoppelt.</small>
          </div>
          <div className="aion-inline-actions">
            <Button
              type="button"
              variant={assistantVoiceProfile === "female" ? "default" : "outline"}
              onClick={() => onVoiceProfileSave("female")}
              disabled={settingsLocked}
              data-testid="aion-voice-profile-female"
            >
              ASTRA · Weiblich
            </Button>
            <Button
              type="button"
              variant={assistantVoiceProfile === "male" ? "default" : "outline"}
              onClick={() => onVoiceProfileSave("male")}
              disabled={settingsLocked}
              data-testid="aion-voice-profile-male"
            >
              ORION · Männlich
            </Button>
          </div>
        </div>

        <div className="aion-note" data-testid="voice-language-mode-note">
          <span className="aion-status-chip" data-testid="voice-language-mode-chip">{voiceLanguageMode === "locked" ? "Fest gespeichert" : "Auto-Sprachen"}</span>
          <strong data-testid="voice-language-mode-copy">{voiceLanguageModeLabel}</strong>
          <small data-testid="voice-language-mode-support-copy">
            {voiceLanguageMode === "auto"
              ? "AION erkennt automatisch eine der 38 freigegebenen Sprachen und antwortet in derselben Sprache."
              : "AION hört und antwortet nur in der ausgewählten Sprache."}
          </small>
        </div>

        <div className="aion-inline-actions">
          <Button type="button" onClick={wakeWordArmed ? voice.stopWakeWordMode : voice.startWakeWordMode} disabled={!wakeWordSupported || voiceMuted || settingsLocked}>{wakeWordArmed ? "Wake Word ausschalten" : "Wake Word AION einschalten"}</Button>
          <span>{wakeWordSupported ? "Aktivierungswort: AION" : "Wake Word in diesem Browser nicht verfügbar"}</span>
        </div>
      </AionSectionCard>
  );
};
